import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { initGlobalErrorHandler } from './utils/globalErrorHandler';
import { initializeReferralTracking } from './utils/referralTracking';

// Initialize tracking BEFORE React renders to capture URL params before any redirects
initializeReferralTracking();
initGlobalErrorHandler();

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Root element not found!');
} else {
  try {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <Router>
          <AuthProvider>
            <App />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: '#2a2a2a',
                  color: '#FFFFFF',
                  border: '1px solid #202020'
                },
                success: {
                  iconTheme: {
                    primary: '#FFCC00',
                    secondary: '#121212'
                  }
                },
                error: {
                  iconTheme: {
                    primary: '#FF3B30',
                    secondary: '#121212'
                  }
                }
              }}
            />
          </AuthProvider>
        </Router>
      </React.StrictMode>
    );
    console.log('App successfully rendered');
  } catch (error) {
    console.error('Error rendering app:', error);
    document.body.innerHTML = `
      <div style="padding: 2rem; text-align: center; color: white; font-family: sans-serif;">
        <h1>Error Rendering Application</h1>
        <p>There was an error rendering the application. Please try refreshing the page.</p>
        <pre style="background: #333; padding: 1rem; text-align: left; overflow: auto; margin-top: 1rem;">${error}</pre>
      </div>
    `;
  }
}